const topicItems = [
  { id: 1, label: '#穿越重生', heat: '🔥 128万热度', rank: 1 },
  { id: 2, label: '#恋爱甜宠', heat: '🔥 96万热度', rank: 2 },
  { id: 3, label: '#逆袭爽文', heat: '🔥 87万热度', rank: 3 },
  { id: 4, label: '#大女主', heat: '75万热度', rank: 4 },
  { id: 5, label: '#悬疑惊悚', heat: '68万热度', rank: 5 },
  { id: 6, label: '#宫廷斗争', heat: '62万热度', rank: 6 },
  { id: 7, label: '#校园纯爱', heat: '58万热度', rank: 7 },
  { id: 8, label: '#奇幻冒险', heat: '53万热度', rank: 8 },
  { id: 9, label: '#职场逆袭', heat: '48万热度', rank: 9 },
  { id: 10, label: '#复仇爽漫', heat: '43万热度', rank: 10 },
  { id: 11, label: '#新番速递', heat: '39万热度', rank: 11 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            话题热榜
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            全网韩漫读者正在热议的话题标签，看看大家都在追什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-3 px-5 py-3 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{
                backgroundColor: item.rank <= 3 ? 'oklch(var(--accent-100) / 0.6)' : 'oklch(var(--background-100))',
                borderColor: item.rank <= 3 ? 'oklch(var(--accent-300) / 0.4)' : 'oklch(var(--background-200) / 0.7)',
              }}
            >
              {item.rank <= 3 && (
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                  {item.rank}
                </span>
              )}
              <span className={`font-medium ${item.rank <= 3 ? 'text-foreground-900' : 'text-foreground-700'} text-sm md:text-base`}>
                {item.label}
              </span>
              <span className="text-xs text-foreground-500">{item.heat}</span>
            </a>
          ))}
        </div>

        <div className="flex justify-center mt-8">
          <a
            href="#topics"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
          >
            查看更多话题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}